"use client";
import React from "react";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function TimelineSection({ heading = "HK Company Formation Timeline 2026, What's Realistic Today?" }: { heading?: string } = {}) {
  const olderTimelines = [
    "in-person bank visits",
    "law firm coordination",
    "manual document couriering",
    "local director requirements",
  ];

  const modernTimelines = [
    "digital-first banking options",
    "streamlined remote incorporation",
    "automated compliance workflows",
    "operational within ~14 days",
  ];

  return (
    <section className="relative w-full bg-black py-[60px] overflow-hidden">
      {/* IMAGE + TEXT TOP */}
      <div className="flex flex-col gap-[32px]">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-[32px] items-center px-4">
          {/* IMAGE */}
          <div className="w-full lg:w-[584px] h-[482px] relative rounded-2xl overflow-hidden">
            <Image
              src="/how-it-work/how-it-frame.webp"
              alt="timeline"
              fill
              className="object-cover"
            />
          </div>

          {/* TEXT */}
          <div className="flex flex-col gap-6 lg:w-[584px]">
            <Heading as="h2" variant="section" className="text-left">
              {heading}
            </Heading>

            <p className="font-suisse-intl text-[16px] text-white/70 leading-[24px] font-medium">
              The timeline above reflects the current HK company formation
              timeline 2026 for remote founders using digital-first structures.
            </p>
          </div>
        </div>

        {/* CARDS SECTION */}
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-8 items-stretch px-4">
          {/* LEFT CARD */}
          <div className="flex-1 bg-[#0f1218] rounded-2xl p-6 flex flex-col gap-6">
            <Heading as="h3" variant="cardTitleLight">
              Older timelines often assumed:
            </Heading>

            <div className="flex flex-col gap-3">
              {[
                "in-person bank visits",
                "law firm coordination",
                "manual document couriering",
                "local director requirements",
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white/5 rounded-lg px-4 py-4 flex items-center gap-3"
                >
                  <Image
                    src="/red-check.svg"
                    alt="cross"
                    width={24}
                    height={24}
                  />
                  <p className="text-white text-[16px]">{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CENTER TEXT */}
          <div className="w-full lg:w-[254px] flex items-center justify-center text-center text-white/70 text-[16px] font-medium leading-6">
            Modern fintech-supported structures remove those delays. That’s how
            most founders today reach operational status within about two weeks.
          </div>

          {/* RIGHT CARD */}
          <div className="flex-1 bg-[#0f1218] rounded-2xl p-6 flex flex-col gap-6">
            <Heading as="h3" variant="cardTitleLight">
              Modern fintech-supported structures:
            </Heading>

            <div className="flex flex-col gap-3">
              {[
                "digital-first banking options",
                "streamlined remote incorporation",
                "automated compliance workflows",
                "operational within ~14 days",
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white/5 rounded-lg px-4 py-3 flex items-center gap-3"
                >
                  <Image
                    src="/green-check.svg"
                    alt="tick"
                    width={28}
                    height={28}
                  />
                  <p className="text-white text-[16px]">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* NOTE */}
    </section>
  );
}
